import React, { useState } from "react";
import { connect } from "react-redux";
import { Form } from "react-final-form";
import arrayMutators from "final-form-arrays";
import { Card, CardBody, CardHeader } from "reactstrap";
import { PacmanLoader } from "react-spinners";

import NotAuthorized from "modules/5_view_helpers/web/NotAuthorized";
import HasRole from "modules/5_view_helpers/HasRole";
import { createStoreRequest } from "../actions";
import StoreRequestFormOutlook from "./form";

const NewStoreRequestOutlook = (props) => {
  const { history } = props;
  const [saving, setSaving] = useState(false);
  const returnUrl = "/";
  const createRole = HasRole({ resource_type: "Store::Request", name: ["create", "moderator"] }, false, true);

  const submitForm = (values) => {
    setSaving(true);
    props
      .createStoreRequest(values)
      .then(() => {
        setSaving(false);
        history.push(returnUrl);
        toastr.success("Store request created");
      })
      .catch(() => {
        setSaving(false);
        toastr.error("Failed to create store request");
      });
  };

  if (!createRole) {
    return <NotAuthorized />;
  }

  if (saving) {
    return (
      <div className="text-center">
        <PacmanLoader />
        Saving...
      </div>
    );
  }

  return (
    <Card>
      <CardHeader>
        <h3>New Store Request</h3>
      </CardHeader>
      <CardBody>
        <Form
          component={StoreRequestFormOutlook}
          onSubmit={submitForm}
          formLabel="Submit Request"
          cancelFunction={() => history.push(returnUrl)}
          mutators={{ ...arrayMutators }}
          initialValues={{
            tool_account: false,
            line_items_attributes: [{ description: "", quantity: 1 }],
          }}
        />
      </CardBody>
    </Card>
  );
};

export default connect(null, { createStoreRequest })(NewStoreRequestOutlook);
